import React from 'react'
import styles from "./footer.module.scss"

export default function Footer (props) {
	return (
		<div className={styles.footer}>
			<div className={styles.container}>
				<p>LukeEdmonds.com</p>
				<a target="_blank" href="https://www.linkedin.com/in/luke-edmonds-73421957/" className="linkedin">Linked In</a>
			</div>
		</div>
	)
}



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js